<div
  class="custom-radio-wrapper btn-group btn-group-toggle {{ hasOnlyText ? 'd-flex justify-content-center align-items-stretch' : '' }}"
  [id]="id"
  ngbRadioGroup
  [formlyAttributes]="field"
  [attr.aria-describedby]="errorId"
  >
  @for (option of (options$ | async) ?? []; track option; let i = $index) {
    <div class="col radio-button-item">
      <input
        class="btn-check"
        type="radio"
        [formControl]="formControl"
        [name]="field.key"
        [value]="option.value"
        [id]="id + '-' + i"
        />
      <label
        [for]="id + '-' + i"
        [ngClass]="isActive(option.value) ? 'active' : ''"
        class="btn btn-2022--secondary d-flex align-items-center justify-content-center custom-radio-label w-100"
        >
        @if (option.icon) {
          <div class="d-flex justify-content-center align-items-center flex-column icon-wrapper">
            <div class="d-flex justify-content-center align-items-center flex-nowrap">
              @for (l of [].constructor(option.repeat || 1); track l) {
                <i class="fas fa-2x fa-{{ option.icon }}"></i>
              }
            </div>
            @if (option.icon && option.label) {
              <small class="icon-text" [ngClass]="{ 'sr-only': option.srOnly }" [attr.for]="id + '-' + i">
                {{ option.label }}
              </small>
            }
          </div>
        }
        @if (!option.icon && option.label) {
          <span class="radio-text" [attr.for]="id + '-' + i">
            {{ option.label }}
          </span>
        }
      </label>
    </div>
  }
</div>

@if (showError && !props.suppressErrors) {
  <div class="invalid-feedback alert alert-danger mt-2 d-flex" [style.display]="'block'">
    <img class="error-icon" src="assets/icons/crossmark-spot-filled.svg">
    <formly-validation-message class="ms-3" [id]="id + '-error-description-id'" [field]="field"></formly-validation-message>
  </div>
}
